// src/app/core/services/institution-settings.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { HttpClientBase } from './http-client-base.service';

export interface InstitutionSettings {
  id: number;
  name: string;
  logoUrl: string | null;
  primaryColor: string | null;
  emailHeader?: string | null;
  emailBody?: string | null;
  emailFooter?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface UpdateInstitutionSettingsDto {
  name?: string;
  primaryColor?: string | null;
  emailHeader?: string | null;
  emailBody?: string | null;
  emailFooter?: string | null;
}

@Injectable({ providedIn: 'root' })
export class InstitutionSettingsService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'institution'); // => baseUrlApi = {environment.base}/institution
  }

  /** GET /institution/settings */
  getSettings(trackLoading = true): Observable<InstitutionSettings | null> {
    return this.get<InstitutionSettings>({
      endpoint: 'settings',
      trackLoading,
    }).pipe(map(resp => resp.body ?? null));
  }

  /** PUT /institution/settings */
  updateSettings(
    dto: UpdateInstitutionSettingsDto,
    trackLoading = true,
  ): Observable<InstitutionSettings> {
    return this.put<InstitutionSettings>(
      dto,
      'settings', 
      undefined,     
      trackLoading,
    );
  }

  /** POST /institution/logo */
  uploadLogo(
    file: File,
    trackLoading = true,
  ): Observable<InstitutionSettings> {
    const formData = new FormData();
    formData.append('file', file); // debe coincidir con FileInterceptor('file')

    // 👇 aquí forzamos que la URL sea {baseUrlApi}/logo
    const url = `${this.baseUrlApi.replace(/\/+$/, '')}/logo`;

    return this.http
      .post<InstitutionSettings>(url, formData, {
        observe: 'response',
        context: this['buildContext'](trackLoading),
      })
      .pipe(map((resp: any) => resp.body as InstitutionSettings));
  }
}
